import { Injectable, Output, EventEmitter, Input } from '@angular/core';

export class HeaderDettaglioScheda {
  titolo: string;
  pathFoto: string;
  dataInizioValidita?: string;
  dataFineValidita?: string;
  contatti?: any;
  idCategoria: number;
  urlEsterno ? = false;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor() {}

  @Output() showDettaglioScheda = new EventEmitter<HeaderDettaglioScheda>();
  @Output() hideDettaglio = new EventEmitter<void>();

  @Output() setTrasparente = new EventEmitter<boolean>();
  @Output() setHomepage = new EventEmitter<boolean>();

  @Output() aggiornaCarrello = new EventEmitter<void>();
  @Output() aggiornaPreferiti = new EventEmitter<void>();

  @Output() setHeaderSecondario = new EventEmitter<boolean>();
}
